export const RESEND_EXPIRY_TIMER = 30;
